export default __webpack_public_path__ + "static/media/noSignalIconSemSobra.bb364cdb.svg";